import { ref } from 'vue';

/**
 * Manages the visible items list for the dropdown.
 *
 * Provides two imperative methods that the component calls
 * when search text changes, the drop list is updated, or
 * the popup opens and selected items need to float to the top.
 */
export function useDropdownItems() {
  const showItems = ref([]);

  /**
   * Filters dropList by searchTxt against the text field and,
   * optionally, the additional field (when additional.useInSearch is true).
   * Resets to the full list when searchTxt is empty.
   */
  function updateBySearch(dropList, searchTxt, resolvedFields) {
    if (!searchTxt) {
      showItems.value = [...dropList];
      return;
    }

    const str = searchTxt.toLowerCase();
    const additionalField = resolvedFields.additional;

    showItems.value = dropList.filter(item => {
      if (item[resolvedFields.text].toLowerCase().includes(str)) return true;

      const additional = additionalField && item[additionalField];

      if (!additional || !additional.useInSearch) return false;

      return additional.text.toLowerCase().includes(str);
    });
  }

  /**
   * Re-orders showItems so that selected items appear first within each group.
   * Called once when the dropdown opens (respects showSelectedFirst prop).
   */
  function sortBySelected(groupSet, itemsByGroup, selectedIds, idField) {
    const result = [];

    groupSet.forEach(groupName => {
      const selected = [];
      const rest = [];

      (itemsByGroup.get(groupName) ?? []).forEach(item => {
        (selectedIds.has(item[idField]) ? selected : rest).push(item);
      });

      result.push(...selected, ...rest);
    });

    showItems.value = result;
  }

  return { showItems, updateBySearch, sortBySelected };
}
